import { useMemo } from 'react';

import { useTracking as useTrackingBase } from '@change-corgi/core/react/tracking';

type Result = {
	track: ReturnType<typeof useTrackingBase>;
	trackScrollMomentumBar: (petitionId: string) => void;
	trackMediaClick: (petitionId: string) => void;
	trackCommentsClick: (petitionId: string) => void;
	trackSpotlightContentClick: (petitionId: string) => void;
	trackSpotlightNavigationClick: (petitionId: string) => void;
	trackVideoPreviewView: (petitionId: string) => void;
	trackSharesClick: (petitionId: string) => void;
};

export function useMomentumBarTracking(): Result {
	const track = useTrackingBase();

	return useMemo(
		() => ({
			track,
			trackScrollMomentumBar: (petitionId) => {
				void track('scroll_momentum_bar', { petition_id: petitionId });
			},
			trackMediaClick: (petitionId) => {
				void track('momentum_bar_media_click', { petition_id: petitionId });
			},
			trackCommentsClick: (petitionId) => {
				void track('momentum_bar_comments_click', { petition_id: petitionId });
			},
			trackSpotlightContentClick: (petitionId) => {
				void track('momentum_bar_spotlight_content_click', { petition_id: petitionId });
			},
			trackSpotlightNavigationClick: (petitionId) => {
				void track('momentum_bar_spotlight_navigation_click', { petition_id: petitionId });
			},
			trackVideoPreviewView: (petitionId) => {
				void track('petition_page_momentum_bar_video_preview_view', { petition_id: petitionId });
			},
			trackSharesClick: (petitionId) => {
				void track('momentum_bar_shares_click', { petition_id: petitionId });
			},
		}),
		[track],
	);
}
